import uploadFileHelper from './uploadFileHelper'

/**
 * Convert a `File` object returned by the upload input into
 * a base 64 string. That's easier to use on FakeRest, used on
 * the ng-admin example. But that's probably not the most optimized
 * way to do in a production database.
 */
const convertFileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file.rawFile)

    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
  })

/**
 * For posts update only, convert uploaded image in base 64 and attach it to
 * the `picture` sent property, with `src` and `title` attributes.
 */
const addUploadCapabilities = (requestHandler) => (type, resource, params) => {
  if (type === 'UPDATE' || type === 'CREATE') {
    const imageParams = uploadFileHelper(resource)
    return Promise.all(
      imageParams
        .filter((imageParam) => params.data.hasOwnProperty(imageParam) && Array.isArray(params.data[imageParam]))
        .map((imageParam) => {
          const newPictures = params.data[imageParam].filter((p) => p.rawFile instanceof File)

          return Promise.all(newPictures.map(convertFileToBase64)).then((base64Pictures) =>
            base64Pictures.map((picture64) => ({ [imageParam]: [{ src: picture64 }] }))
          )
        })
    )
      .then((base64ImageValues) => {
        if (base64ImageValues.length === 0) {
          return Promise.resolve({})
        }
        const imagesResult = base64ImageValues.reduce((accumulator, currentValue) => accumulator.concat(currentValue))
        const imageParams = imagesResult.reduce((accumulator, currentValue) => Object.assign(accumulator, currentValue))
        return Promise.resolve(imageParams)
      })
      .then((imageParams) =>
        requestHandler(type, resource, {
          ...params,
          data: {
            ...params.data,
            ...imageParams,
          },
        })
      )
  }

  return requestHandler(type, resource, params)
}

export default addUploadCapabilities



// WEBPACK FOOTER //
// ./src/addUploadFeature.js